(function () {
  const SELECTOR = '#FreeGiftCart';
  const EVENTS = ['cart:updated', 'cart:change', 'ajaxCart:updated'];

  async function syncFreeGiftUi() {
    const container = document.querySelector(SELECTOR);
    if (!container) return;

    const giftHandle = container.dataset.giftHandle; // "bland-selv-3-pakke"
    if (!giftHandle) return;

    let cart;
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      cart = await res.json();
    } catch (e) {
      return;
    }

    const giftInCart = (cart.items || []).some((i) => i.handle === giftHandle);
    const msg = container.querySelector('.free-gift-cart__message');
    const offer = container.querySelector('.free-gift-cart__offer');

    if (giftInCart) {
      container.classList.add('free-gift-cart--success');
      if (msg) {
        msg.innerHTML = `
          Gave tilføjet!
          <span class="free-gift-cart__subtext">
            Du ser den som et gratis produkt i kurven og i checkout.
          </span>
        `;
        msg.dataset.state = 'added';
      }
      if (offer) offer.remove();
    } else {
      // Hvis du vil, kan du “resette” UI her.
      // Jeg anbefaler at lade Liquid bestemme standard-teksten,
      // så her gør vi ingenting når den ikke er i kurven.
      container.classList.remove('free-gift-cart--success');
    }
  }

  // Kør når siden loader
  document.addEventListener('DOMContentLoaded', syncFreeGiftUi);

  // Kør når man kommer tilbage fra produktsiden (BFCache på iOS kan drille)
  window.addEventListener('pageshow', syncFreeGiftUi);

  // Lyt på temaets cart-events
  EVENTS.forEach((name) => {
    document.addEventListener(name, syncFreeGiftUi);
  });

  // BONUS: Hvis dit tema ikke emitter events, kan du hooke på Shopify events hvis de findes
  document.addEventListener('cart:refresh', syncFreeGiftUi);
})();
